import { useState } from "react";
import { useAuth } from "../context/AuthContext";

export default function ForgotPassword({ navigate }) {
  const { findUser } = useAuth();
  const [email,   setEmail]   = useState("");
  const [msg,     setMsg]     = useState(null);
  const [success, setSuccess] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const r = await findUser(email);
    if (r.found) {
      setMsg(`✅ Account found! A new temporary password has been issued: ${r.tempPassword} — please login with this and change it from Settings.`);
      setSuccess(true);
    } else {
      setMsg("No account found with that email address. Please check and try again.");
      setSuccess(false);
    }
  };

  return (
    <div style={{minHeight:"100vh",background:"#f0f3f9",display:"flex",alignItems:"center",justifyContent:"center",padding:20,fontFamily:"'DM Sans',sans-serif"}}>
      <div style={{background:"#fff",borderRadius:20,padding:"44px 42px",maxWidth:460,width:"100%",boxShadow:"0 8px 40px rgba(10,22,40,0.1)",border:"1px solid #e4e9f0",position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",top:0,left:0,right:0,height:4,background:"linear-gradient(135deg,#4a7fb5,#d4736a)"}}/>

        <div style={{textAlign:"center",marginBottom:24}}>
          <img src="/logo-small.png" alt="AIHOVI B2B" style={{height:74,objectFit:"contain"}} onError={e=>e.target.style.display="none"}/>
        </div>

        <h1 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:28,fontWeight:700,color:"#0d1f3c",textAlign:"center",marginBottom:8}}>Forgot Password?</h1>
        <p style={{fontSize:13,color:"#6b7a90",textAlign:"center",lineHeight:1.6,marginBottom:26}}>Enter your registered email address.<br/>We'll show your reset instructions.</p>

        {msg && (
          <div style={{background:success?"#dcfce7":"#fee2e2",border:`1.5px solid ${success?"#22c55e":"#ef4444"}`,color:success?"#166534":"#991b1b",padding:"14px 16px",borderRadius:10,fontSize:13,marginBottom:20,lineHeight:1.6}}>
            {msg}
          </div>
        )}

        {!success && (
          <form onSubmit={submit}>
            <div style={{marginBottom:18}}>
              <label style={{display:"block",fontSize:11,fontWeight:600,letterSpacing:"1.5px",textTransform:"uppercase",color:"#5a6a80",marginBottom:7}}>Registered Email</label>
              <div style={{position:"relative"}}>
                <span style={{position:"absolute",left:13,top:"50%",transform:"translateY(-50%)",fontSize:15}}>📧</span>
                <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="e.g. admin@airhotelvisa.com" required
                  style={{width:"100%",padding:"13px 14px 13px 40px",border:"1.5px solid #dde3ed",borderRadius:10,fontSize:13,fontFamily:"'DM Sans',sans-serif",color:"#0d1f3c",background:"#fafbfd",outline:"none",boxSizing:"border-box"}}
                  onFocus={e=>e.target.style.borderColor="#4a7fb5"} onBlur={e=>e.target.style.borderColor="#dde3ed"}/>
              </div>
            </div>
            <button type="submit" style={{width:"100%",padding:13,background:"linear-gradient(135deg,#4a7fb5,#d4736a)",color:"#fff",fontFamily:"'DM Sans',sans-serif",fontSize:14,fontWeight:600,border:"none",borderRadius:10,cursor:"pointer"}}>
              Send Reset Instructions →
            </button>
          </form>
        )}

        <div style={{marginTop:22,display:"flex",flexDirection:"column",gap:10,alignItems:"center",borderTop:"1px solid #eaeef5",paddingTop:18}}>
          <a onClick={()=>navigate("login")}    style={{fontSize:13,color:"#4a7fb5",cursor:"pointer",textDecoration:"none"}}>← Back to Login</a>
          <a onClick={()=>navigate("register")} style={{fontSize:13,color:"#4a7fb5",cursor:"pointer",textDecoration:"none"}}>Don't have an account? Register</a>
        </div>
      </div>
    </div>
  );
}
